import { MenuPosition } from 'react-select'

import { Select } from '@/components/select'
import { useOrganizationId } from '@/hooks/use-organization-id'
import { useEmailTemplatesByOrganization } from '@/modules/email-template/presentation/hooks/useEmailTemplates'
import { EmailTemplatesScope } from '@/shared/domain/enums/email-templates-scope.enum'

export function OrganizationEmailTemplatesSelect({
  menuPosition = 'absolute',
  onChange,
  scope,
  value,
}: {
  value?: string | null
  onChange: (value: string) => void
  scope: keyof typeof EmailTemplatesScope
  menuPosition?: MenuPosition
}) {
  // TODO: Maybe we should use the organizationId from the parent component
  const { organizationId } = useOrganizationId()
  const { data: emailTemplates, isLoading } = useEmailTemplatesByOrganization(organizationId, scope)

  return (
    <Select
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id}
      isLoading={isLoading}
      menuPosition={menuPosition}
      onChange={(value) => value && onChange(value.id)}
      options={emailTemplates}
      placeholder="Select email template..."
      value={emailTemplates?.find((opt) => opt.id === value)}
    />
  )
}
